const carouselItems = [
  {
    title: '奔跑吧 · 第十季',
    subtitle: '户外竞技综艺天花板',
    desc: '全新一季跑男团强势回归，经典撕名牌环节升级回归。泥潭大战、水上竞技、城市追逐，笑点密集全程高能。每周五晚准时更新，不容错过的国民综艺。',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20group%20of%20people%20running%20through%20colorful%20urban%20park%20with%20confetti%20and%20celebration%20atmosphere%20warm%20golden%20hour%20sunlight%20energetic%20team%20spirit%20cinematic%20wide%20shot%20variety%20show%20poster%20aesthetic%20vibrant%20orange%20and%20coral%20tones&width=1000&height=560&seq=carousel-01-6080&orientation=landscape',
    badge: '热度TOP1',
  },
  {
    title: '歌手2025',
    subtitle: '顶级音乐竞演舞台',
    desc: '华语乐坛顶级唱将同台竞技，每一场都是视听盛宴。全新赛制升级，帮帮唱环节阵容空前。高音炸裂、情感催泪，每周六晚音乐狂欢不停歇。',
    img: 'https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20dramatic%20spotlight%20beams%20and%20atmospheric%20smoke%20musical%20instruments%20silhouettes%20golden%20and%20amber%20lighting%20professional%20music%20performance%20atmosphere%20wide%20cinematic%20shot%20elegant%20and%20powerful%20stage%20design&width=1000&height=560&seq=carousel-02-6080&orientation=landscape',
    badge: '口碑爆款',
  },
  {
    title: '密室大逃脱 · 第六季',
    subtitle: '沉浸式烧脑解谜体验',
    desc: '第六季密室场景全面升级，古堡、医院、实验室等全新主题。明星嘉宾智商在线，悬疑氛围拉满。每一期都是一部微型悬疑电影，胆小也要看的高能综艺。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20ancient%20library%20interior%20with%20dim%20candlelight%20and%20dusty%20bookshelves%20hidden%20passageways%20and%20cryptic%20symbols%20warm%20amber%20glow%20casting%20long%20shadows%20suspenseful%20cinematic%20atmosphere%20with%20rich%20wood%20textures%20and%20vintage%20details&width=1000&height=560&seq=carousel-03-6080&orientation=landscape',
    badge: '新季上线',
  },
  {
    title: '乘风破浪 · 第四季',
    subtitle: '女性励志成长音乐竞演',
    desc: '30+姐姐突破自我重新出发，用实力证明年龄只是数字。从初舞台到成团夜，每一个公演都是惊艳全场的高光时刻。女性的力量与魅力，在这里被完美诠释。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20stage%20performance%20with%20group%20of%20women%20in%20flowing%20dresses%20dynamic%20dance%20formation%20sparkling%20stage%20lights%20in%20rose%20gold%20and%20warm%20tones%20empowering%20atmosphere%20confetti%20falling%20cinematic%20wide%20shot%20glamorous%20entertainment&width=1000&height=560&seq=carousel-04-6080&orientation=landscape',
    badge: '成团之夜',
  },
  {
    title: '脱口秀大会 · 第五季',
    subtitle: '爆笑语言类综艺首选',
    desc: '新老脱口秀演员爆笑对决，犀利吐槽社会热点加温暖治愈人生故事。笑中带泪、燃中带暖，是下班后最解压的快乐源泉。每期都有出圈爆梗刷屏社交网络。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20intimate%20comedy%20theater%20with%20single%20microphone%20under%20soft%20spotlight%20red%20velvet%20curtains%20cozy%20atmosphere%20with%20warm%20tungsten%20lighting%20audience%20silhouettes%20laughter%20and%20joy%20vibe%20professional%20standup%20comedy%20venue%20wide%20shot&width=1000&height=560&seq=carousel-05-6080&orientation=landscape',
    badge: '爆笑推荐',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
            <i className="ri-shining-line text-primary-400 text-xs"></i>
            <span className="text-xs text-primary-400 font-medium whitespace-nowrap">编辑力荐</span>
          </div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-100 mb-3">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            本期不容错过的五档必追综艺，每一部都值得拥有
          </p>
        </div>

        <div className="space-y-5">
          {carouselItems.map((item) => (
            <a
              key={item.title}
              href="#carousel"
              onClick={(e) => e.preventDefault()}
              className="group block cursor-pointer"
            >
              <div className="bg-background-50 rounded-xl overflow-hidden border border-background-300/20 transition-all duration-300 hover:border-primary-500/30">
                <div className="flex flex-col lg:flex-row">
                  <div className="lg:w-[420px] flex-shrink-0 relative overflow-hidden">
                    <div className="aspect-[16/10] lg:aspect-auto lg:h-full">
                      <img
                        src={item.img}
                        alt={item.title}
                        className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>
                    <div className="absolute top-4 left-4">
                      <span className="px-3 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                        {item.badge}
                      </span>
                    </div>
                  </div>
                  <div className="flex-1 p-6 md:p-8 flex flex-col justify-center">
                    <span className="text-xs text-accent-400 font-medium mb-2 whitespace-nowrap">{item.subtitle}</span>
                    <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-100 mb-3 group-hover:text-primary-400 transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                    <div className="mt-4 flex items-center gap-2 text-primary-400 text-sm font-medium">
                      <span className="whitespace-nowrap">立即观看</span>
                      <i className="ri-arrow-right-line text-sm transition-transform duration-300 group-hover:translate-x-1"></i>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}